module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.product && _vm.prodCoupons) ? _c('div', {
    staticClass: "valid-coupons",
    on: {
      "click": _vm.showCoupons
    }
  }, [_c('div', {
    staticClass: "coupon-items"
  }, _vm._l((_vm.prodCoupons), function(item) {
    return _c('div', {
      staticClass: "c-item"
    }, [_vm._v("\n      " + _vm._s(item.couponContentDesc) + "\n    ")])
  }), 0), _vm._v(" "), _vm._m(0)]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "get-coupon"
  }, [_vm._v("去领券"), _c('i')])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fff4617e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./static/app-product-detail/components/coupons.vue
// module id = 1012
// module chunks = 2